import axios from 'axios';
import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_PURCASE = 'GET_PURCASE';
export const GET_PURCASE_SUCCESS = 'GET_PURCASE_SUCCESS';
export const GET_PURCASE_FAILURE = 'GET_PURCASE_FAILURE';

// Action Creators
export const getPurchaseRequest = () => ({
  type: GET_PURCASE,
});

export const getPurchaseSuccess = (users) => ({
  type: GET_PURCASE_SUCCESS,
  payload: users,
});

export const getPurchaseFailure = (error) => ({
  type: GET_PURCASE_FAILURE,
  payload: error,
});

// Thunk Function
export const postPurchase = (external, body) => {
  return async (dispatch) => {
    dispatch(getPurchaseRequest());
    try {
      const response = await postMethodWithToken(url?.purchaseDoctor, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getPurchaseSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getPurchaseFailure(error?.message));
    }
  };
};
